(function () {
  if (window.__usHome) return;
  window.__usHome = true;
  var nativeFetch = window.fetch.bind(window);
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function fmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var v = cents / 100;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); } catch (e) { return '$' + v.toFixed(2); }
  }
  function render(total) {
    document.querySelectorAll('[data-us-ship]').forEach(function (el) {
      var rem = parseInt(el.getAttribute('data-us-threshold'), 10) - total;
      el.textContent = rem > 0 ? el.getAttribute('data-us-away').replace('[amount]', fmt(rem)) : el.getAttribute('data-us-done');
    });
  }
  function refresh() {
    nativeFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price); })
      .catch(function () {});
  }
  var cartUrls = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  window.fetch = function (input) {
    var p = nativeFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (cartUrls.some(function (k) { return url.indexOf(k) > -1; })) p.then(function () { setTimeout(refresh, 300); });
    } catch (e) {}
    return p;
  };
  document.addEventListener('cart:update', refresh);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-us-atc]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-adding') || 'Adding...';
    nativeFetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add'); return d; }); })
      .then(function () { window.location.href = root() + 'cart'; })
      .catch(function (err) {
        btn.textContent = String(err.message || 'Error').slice(0, 40);
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2500);
      });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-us-copy]');
    if (!b || !navigator.clipboard) return;
    var t = b.textContent;
    navigator.clipboard.writeText(b.getAttribute('data-us-copy')).then(function () {
      b.textContent = 'COPIED!';
      setTimeout(function () { b.textContent = t; }, 1500);
    });
  });
})();
